<template>
    <div>
      <main-layout
        controlsBg="light"
        :hasControlsBar="false"
        :breadcrumb="getBreadcrumb">
        <grid-row column-align="center" col-spaced>
          <grid-col col-size="4">
            <h1 class="header margin-top-xl">
              <chevron
                @click="$router.push({name: 'Explore'})"/>
              {{ $t('menu.correlation') }}
            </h1>
          </grid-col>
        </grid-row>
        <grid-row column-align="center" class="margin-top-xxl">
          <grid-col col-size="4">
            <div class="center-horizontal">
              <!-- Correlation -->
              <safe-router-link to="/explorer-correlation-variables" class="nav__menu-item">
                <div v-has-feature="'Explore'" class="personal-area-element">
                  <icon-correlations class="personal-area-element-icon" />
                  <div class="personal-area-element-title">{{ $t('menu.correlation') }}</div>
                </div>
              </safe-router-link>

              <!-- Multiple correlation -->
              <safe-router-link to="/explorer-multiple-correlation-variables" class="nav__menu-item">
                <div v-has-feature="'Explore'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icon.multipleCorrelation"
                    class="personal-area-element-font-icon"/>
                  <div class="personal-area-element-title">{{ $t('explorer.multipleCorrelation') }}</div>
                </div>
              </safe-router-link>
            </div>
          </grid-col>
        </grid-row>
      </main-layout>
    </div>
</template>

<script>
import MainLayout from '../MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import SafeRouterLink from '../../components/shared/SafeRouterLink';
import Chevron from '@/components/shared/Chevron';
import {faBalanceScaleLeft} from '@fortawesome/pro-light-svg-icons';
import IconCorrelations from '@/components/shared/icons/IconCorrelations';

export default {
  name: 'ExplorerCorrelationMenu',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    FontAwesomeIcon,
    SafeRouterLink,
    Chevron,
    IconCorrelations
  },
  data () {
    return {
      icon: {
        multipleCorrelation: faBalanceScaleLeft
      },
      breadcrumb: [
        {link: '/explore', nameKey: 'menu.explorer'},
        {link: '/explore/menu', nameKey: 'menu.correlation', disabled: true}
      ]
    };
  },
  computed: {
    getBreadcrumb () {
      return this.breadcrumb.map(route => {
        route.name = this.$t(route.nameKey);
        return route;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "src/stylesheets/variables";

  /deep/ .header {
    display: block !important;
  }

  h1 {
    margin-right: $sp-margin;
    padding-right: $sp-margin;
    margin-left: $sp-margin;
  }

  h2 {
    line-height: 2.2;
    font-size: 1.2rem;
    font-weight: lighter;
  }

  .personal-area-element {
    align-items: center;
    display: inline-block;
    text-align: center;
    background-color: $black-light9;
    border: solid 0.2rem $black-light9;
    border-radius: $radius;
    height: 15rem;
    width: 15rem;
    color: $secondary;
    margin: 1rem;
    padding-top: 2.7rem;
  }

  .personal-area-element:hover {
    border: solid 0.2rem $black-light5;
  }

  .personal-area-element-icon {
    width: 7rem;
    color: $secondary;
  }

  .personal-area-element-font-icon {
    font-size: 7.5rem;
    width: 7rem;
    color: $secondary;
  }

  .personal-area-element-title {
    font-size: 1.3rem;
    font-weight: bold;
  }

  .disabled, .disabled:hover{
    color: $secondary-trans7;
    border: solid 0.2rem $black-light9;
  }

  .center-horizontal {
    display: table;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/explorer/ExplorerCorrelationMenu.vue